const Scadenze730 = {
  Agosto23: 0,
  Agosto31: 1,
  Settembre22: 2,
  UltimaScadenza: 3,
  TermineUltimo: 4,
  NonSelezionato: -1,
};

const toString = (tipo) => {
  switch (tipo) {
    case Scadenze730.Agosto23:
      return '23 Agosto ore 24.00';
    case Scadenze730.Agosto31:
      return '31 Agosto ore 24.00';
    case Scadenze730.Settembre22:
      return '22 Settembre ore 24.00';
    case Scadenze730.UltimaScadenza:
      return '28 Settembre ore 13.00';
    case Scadenze730.TermineUltimo:
      return '28 Settembre ore 16.00';
    default:
      return '';
  }
};

Scadenze730.stringify = toString;

export default Scadenze730;
